<template>
  <div>
    <!-- Table Container Card -->
    <b-card no-body class="mb-0">
      <b-row class="m-2">
        <b-col cols="12" md="2">
          <b-button @click="refetchData" variant="primary" size="sm" class="mr-2">
            <span class="text-nowrap">
              <feather-icon icon="RefreshCwIcon" style="color: #fff" />
            </span> </b-button
          >
          <vue-excel-xlsx
            size="sm"
            variant="success"
            class="btn btn-success sm btn-sm"
            :data="datatableArrayData"
            :columns="json_fields"
            :file-type="'xlsx'"
            :file-name="fileName"
            :sheet-name="sheetName" 
          >
          <feather-icon icon="DownloadIcon" style="color: #fff" />
          </vue-excel-xlsx>
        </b-col>

        <b-col cols="12" md="10">
          <b-row>
            <data-filters
              :branch-filter.sync="branchFilter"
              :branch-options="branchOptions"
              :month-filter.sync="monthFilter"
              :month-options="monthOptions"
              :date-filter.sync="dateFilter"
              :date-finale-filter.sync="dateFinaleFilter"
              :date-options="dateOptions"
              style="width: 100%; margin-left:0px;margin-right:0px; padding:0px;margin:0px"
              size="sm"
            />
          </b-row>
        </b-col>
 
      </b-row> 

      <b-table
        ref="refDataListTable"
        class="position-relative"
        :items="fetchModulerepportposes"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="Aucun resultat trouvé"
        :sort-desc.sync="isSortDirDesc"
      >
        <template #cell(id)="data">
          <b-badge
            pill
            :variant="`light-${resolveDataStatusVariant(data.item.status)}`"
            class="text-capitalize"
          >
            {{ data.index + 1 }}
          </b-badge>
        </template>
        <!-- Column: branch -->
        <template #cell(bank)="data">
          {{ data.item.bank.name }}
        </template>

        <template #cell(bank_account)="data">
          {{ data.item.bank_account.number }}
        </template>
        <!-- Column: amount -->
        <template #cell(amount)="data"> {{ data.item.amount }} $ </template>

        <!-- Column: Status -->
        <template #cell(status)="data">
          <b-badge pill variant="success" class="text-capitalize">
            <feather-icon icon="ArrowDownIcon" size="18" />
            <feather-icon
              icon="ArrowUpIcon"
              v-if="data.item.status > 1"
              size="18"
            />

            <feather-icon
              :id="`repportpos-row-${data.item.id}-preview-icon`"
              icon="EyeIcon"
              size="16"
              @click="
                $router.push({
                  name: 'repportpos-view',
                  params: { id: data.item.id },
                })
              "
            />
            <b-tooltip
              title="Visionner"
              :target="`repportpos-row-${data.item.id}-preview-icon`"
            />
          </b-badge>
        </template>
      </b-table>

      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <font style="font-size: 25px; color: red"> TOTAL </font>
          </b-col>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <font style="font-size: 25px; color: red"> {{ totalAmount }}</font>
          </b-col>
        </b-row>
      </div>

      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted"
              >Affiché {{ dataMeta.from }} à {{ dataMeta.to }} sur
              {{ dataMeta.of }} Enregistements</span
            >
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="totalDatas"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BTooltip,
  BDropdown,
  BDropdownItem,
  BPagination,
} from "bootstrap-vue";
import vSelect from "vue-select";
import store from "@/store";
import { ref, onUnmounted } from "@vue/composition-api";
import { avatarText } from "@core/utils/filter";
import useModuleList from "./useList";
import storeModule from "./storeModule";
// import ListDataTable from "./ListDataTable.vue";
import DataFilters from "./DataFilters.vue";

// sweet alert
import Ripple from "vue-ripple-directive";

export default {
  components: {
    DataFilters,
    // ListDataTable,

    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BTooltip,
    BDropdown,
    BDropdownItem,
    BPagination,
    vSelect,
  },
  data() {
    return {
      branchOptions: [],
      typeOptions: [{ label: "*", value: 0 }],
      fileName: "SPPRF-EXPORT-RAPPORT",
      sheetName: "RAPPORT",
      json_fields: [
        {
          label: "Poste Frontalier",
          field: "sku_branch",
        },
        {
          label: "Date",
          field: "date",
          dataFormat: this.priceFormat,
        },
        {
          label: "Camion Remorque",
          field: "camion_remorque",
        },
        {
          label: "Camion",
          field: "camion",
        },
        {
          label: "Véh. Léger",
          field: "vehicule_leger",
        },
        {
          label: "Banque",
          field: "bank.name",
        },
        {
          label: "N° Compte",
          field: "bank_account.number",
        },
        {
          label: "Réf. Bordereau",
          field: "bordereau",
        },
        {
          label: "Montant (USD)",
          field: "amount",
          dataFormat: this.priceFormat,
        },
      ],
    };
  },
  async mounted() {
    this.getBranchesAndTarifs();

    window.setInterval(() => {
      this.refetchData();
    }, 60000);
  },
  directives: {
    Ripple,
  },
  props: {},
  methods: {
    async getBranchesAndTarifs() {
      await myApi
        .get(`branch_and_tarifs`)
        .then((response) => {
          // default action
          var branchsData = response.data.branches;
          var tarifsData = response.data.tarifs;

          var branchCount = branchsData.length;
          if (branchCount >= 3) {
            this.branchOptions.push({ label: "*", value: 0 });
          }
          var i = 0;
          for (i = 0; i < branchCount; i++) {
            this.branchOptions.push({
              label: branchsData[i].name,
              value: branchsData[i].id,
            });
          }

          var j = 0;
          for (j = 0; j < tarifsData.length; j++) {
            this.typeOptions.push({
              label: tarifsData[j].vehicle_category,
              value: tarifsData[j].id,
            });
          }
        })
        .catch((error) => {
          //
          console.log(error);
        });
    },
    onDeleteQuestion(repportpos) {
      this.$swal({
        title: "Action Irreversible",
        text: "Voulez-vous vraiment supprimer ?",
        icon: "question",
        timer: 10000,
        showCancelButton: true,
        confirmButtonText: "Oui [Confirmer Suppression]",
        cancelButtonText: "Annuler",
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-outline-primary ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          // yes
          this.onDelete(repportpos);
        } else if (result.dismiss === "cancel") {
          // stay here
        }
      });
    },
  },
  setup() {
    const APP_STORE_MODULE_NAME = "repportpos";

    // Register module
    if (!store.hasModule(APP_STORE_MODULE_NAME))
      store.registerModule(APP_STORE_MODULE_NAME, storeModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(APP_STORE_MODULE_NAME))
        store.unregisterModule(APP_STORE_MODULE_NAME);
    });

    const onDelete = (repportpos) => {
      store
        .dispatch(APP_STORE_MODULE_NAME + "/deleteModule", repportpos.id)
        .then(() => {
          // show confirmation notification
          refetchData();
        });
    };

    const isAddNewDataSidebarActive = ref(false);

    const statusOptions = [{ label: "*", value: 0 }];

    const monthOptions = [
      { label: "*", value: "" },
      { label: "Janvier", value: "1" },
      { label: "Février", value: "2" },
      { label: "Mars", value: "3" },
      { label: "Avril", value: "4" },
      { label: "Mai", value: "5" },
      { label: "Juin", value: "6" },
      { label: "Juillet", value: "7" },
      { label: "Aout", value: "8" },
      { label: "Septembre", value: "9" },
      { label: "Octobre", value: " 10" },
      { label: "Novembre", value: "11" },
      { label: "Décembre", value: "12" },
    ];

    var today = new Date();
    var dd = String(today.getDate()).padStart(2, "0");
    var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
    var yyyy = today.getFullYear();

    const dateOptions = [
      { label: "Aujourdhui", value: dd + "-" + mm + "-" + yyyy },
    ];

    const {
      fetchModulerepportposes,
      tableColumns,
      perPage,
      currentPage,
      totalDatas,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      totalAmount,
      isSortDirDesc,
      refDataListTable,
      refetchData,
      datatableArrayData,
      // UI
      resolveDataTypeVariant,
      resolveDataTypeIcon,
      resolveDataStatusVariant,

      // Extra Filters
      statusFilter,
      branchFilter,
      monthFilter,
      dateFilter,
      dateFinaleFilter,
      typeFilter,
    } = useModuleList();

    return {
      // Sidebar
      isAddNewDataSidebarActive,

      fetchModulerepportposes,
      tableColumns,
      perPage,
      currentPage,
      totalDatas,
      totalAmount,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refDataListTable,
      refetchData,
      datatableArrayData,

      onDelete,

      // Filter
      avatarText,

      // UI
      resolveDataTypeVariant,
      resolveDataTypeIcon,
      resolveDataStatusVariant,

      statusOptions,
      dateOptions,
      monthOptions,

      // Extra Filters
      statusFilter,
      branchFilter,
      monthFilter,
      dateFilter,
      dateFinaleFilter,
      typeFilter,
    };
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
